import React from "react";
import "./Splash.style.css";
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import UserButton from "../components/UserButton";
import { useNavigate } from "react-router-dom";
import { RoutesConfig } from "../router/types";
import { useUserStore } from "../store/userStore";

export const Splash: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const clientName = useUserStore((state) => state.clientName);
  const picture = useUserStore((state) => state.picture);

  const handleQuickLogin = () => {
    navigate(RoutesConfig.HOME.path);
  };

  return (
    <>
      <div className="bg-image"></div>
      <div className="container">
        <img src="/braxcomTracking.svg" width={isMobile ? "100%" : "80%"} />
        {clientName && (
          <div className="recent-avatar-button">
            <UserButton
              picture={picture}
              recentUser={clientName ?? ""}
              onClick={handleQuickLogin}
            />
          </div>
        )}
        <div className="button-group">
          {/* <Button
            variant="outlined"
            sx={{ textTransform: "none" }}
            className="btn"
            onClick={() => navigate(RoutesConfig.REGISTER.path)}
          >
            Cadastro
          </Button> */}
          <Button
            variant="contained"
            sx={{ textTransform: "none", width: "200px" }}
            className="btn"
            onClick={() => navigate("/login")}
          >
            Login
          </Button>
        </div>
      </div>
      <footer className="splash-footer">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ color: "white" }}>Producted by </span>
          <img src="/logoEnigme.png" alt="Logo" className="footer-logo" />
        </Box>
      </footer>
    </>
  );
};
